import axios from 'axios'
import { addSentryBreadcrumb } from '@/utils/errorHandler'

export default {
    setAppUpdateState({ commit }, boolean) {
        commit('SET_APP_UPDATE_STATE', boolean)
    },
    
    showNotification({ commit }, payload) {
        commit('SHOW_NOTIFICATION', {
            type: payload.type,
            message: payload.message,
            action: payload.action,
            timeout: typeof payload.timeout === 'undefined' ? 5000 : payload.timeout
        })
        addSentryBreadcrumb('ui.action', 'Powiadomienie', { data: payload.message })
    },
    hideNotification({ commit }) {
        commit('HIDE_NOTIFICATION')
    },

    toggleMainLoader({ commit }, boolean) {
        commit('TOGGLE_MAIN_LOADER', boolean)
    },

    toggleCircularLoader({ commit }, boolean) {
        commit('TOGGLE_CIRCULAR_LOADER', boolean)
    },

    getErrorCodes({ commit }) {
        return axios
            .get('/globals/dicts/error-codes')
            .then(response => {
                commit('GET_ERROR_CODES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },

    savePagination({ commit }, paginationData) {
        commit('SAVE_PAGINATION', paginationData)
    },
    clearPagination({ commit }) {
        commit('CLEAR_PAGINATION')
    },

    setDeviceCameras({ commit }, data) {
        commit('SET_DEVICE_CAMERAS', data)
    },

    setSelectedListItemId({ commit }, id) {
        commit('SET_SELECTED_LIST_ITEM_ID', id)
    },
    clearSelectedListItemId({ commit }, id) {
        commit('CLEAR_SELECTED_LIST_ITEM_ID', id)
    }
}
